/* Components */
export { DownloadButtonComponent } from "./Component/Buttons/DownloadButtonComponent";
export { FooterComponent } from "./Component/Layout/FooterComponent";
export { HeaderComponent } from "./Component/Layout/HeaderComponent";

/* Constants */
export { route } from "./constants/API.Routes";
export {
  persistPartnerAgreement,
  getPartnerAgreementPersist,
  getDownloadCode,
} from "./js/persistEmail";

//module.exports = { DownloadButtonComponent, FooterComponent, HeaderComponent, constant, persistPartnerAgreement, getPartnerAgreementPersist }



// WEBPACK FOOTER //
// ./src/modules/AppCore/index.js